<template>
  <div class="history-trip-box" v-if="list.length > 0" :type="type">
    <hs-scroll :data="[]" class="table-view-horizontal" direction="horizontal">
      <div class="notice-tab-list" >
        <div
          class="item"
          v-for="(item, i) in list"
          :key="i"
          @click="$emit('select', item)"
        >
          <template v-if="storageKey === 'HISTORY_TRIP_PLANE_CITY'">
            {{getAirPortName(item.DepartObject)}} - {{getAirPortName(item.ArrivalObject)}}
          </template>
          <template v-else-if="storageKey === 'HISTORY_TRIP_BUS_CITY'">
            {{item.DepartObject.StationName ? item.DepartObject.StationName : getCityName(item.DepartObject)}} - {{item.ArrivalObject.StationName ? item.ArrivalObject.StationName : getCityName(item.ArrivalObject)}}
          </template>
          <template v-else-if="storageKey === 'HISTORY_TRIP_TRAIN_CITY'">
            {{getCityName(item.DepartObject)}} - {{getCityName(item.ArrivalObject)}}
          </template>
        </div>
      </div>
    </hs-scroll>
    <div v-if="type === 'new-style'" class="item clear" key="clear" @click="_clear" >{{$t('Clear')}}</div>
    <div v-if="type !== 'new-style'" class="clear" @click="_clear">{{$t('Clear')}}</div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    storageKey: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 6
    },
    hasInterPlanePower: { // 是否有国际机票的查询权限
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.initHistoryTripStorage()
  },
  watch: {
    hasInterPlanePower() {
      this.initHistoryTripStorage()
    }
  },
  methods: {
    initHistoryTripStorage() {
      let HistoryTrip = window.localStorage[this.storageKey]
      if (HistoryTrip) {
        this.list = this._getFilterInterPlaneCityHistory()
        console.log(this.list)
      }
    },

    /** 过滤国际机票城市当前历史缓存数据 */
    _getFilterInterPlaneCityHistory() {
      let list = window.localStorage[this.storageKey] ? JSON.parse(window.localStorage[this.storageKey]) : []
      if (!this.hasInterPlanePower && this.storageKey === 'HISTORY_TRIP_PLANE_CITY') {
        return list.filter(v => v.DepartObject.CountryType !== '国际' && v.ArrivalObject.CountryType !== '国际')
      } else {
        return list
      }
    },

    setHistoryTripStorage(val) {
      this.list = [val, ...this._getFilterDuplicateData(val, this.list)]
      this.list = this.list.slice(0, this.size)
      window.localStorage[this.storageKey] = JSON.stringify(this.list)
    },
    // 过滤重复数据
    _getFilterDuplicateData(val, list = []) {
      let {DepartObject, ArrivalObject} = val
      if (this.storageKey === 'HISTORY_TRIP_PLANE_CITY') { // 机票
        return list.filter(m => m.DepartObject.AirPortCode !== DepartObject.AirPortCode || m.ArrivalObject.AirPortCode !== ArrivalObject.AirPortCode)
      } else if (this.storageKey === 'HISTORY_TRIP_BUS_CITY') {
        return list.filter(m =>
          (
            ((!m.DepartObject.StationCode || !m.ArrivalObject.StationCode) && (m.DepartObject.CityCode !== DepartObject.CityCode || m.ArrivalObject.CityCode !== ArrivalObject.CityCode)) ||
            ((m.DepartObject.StationCode && m.ArrivalObject.StationCode) && (m.DepartObject.StationCode !== DepartObject.StationCode || m.ArrivalObject.StationCode !== ArrivalObject.StationCode))
          )
        )
      } else {
        return list.filter(m => m.DepartObject.CityCode !== DepartObject.CityCode || m.ArrivalObject.CityCode !== ArrivalObject.CityCode)
      }
    },

    _clear() {
      this.list = []
      window.localStorage[this.storageKey] = JSON.stringify(this.list)
    }
  },
  components: {
    HsScroll: () => import('base/hs-scroll/hs-scroll')
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.history-trip-box
  @extend .flex-between
  display inline-flex
  max-width 100%
  margin-top 25px
  &[type="new-style"]
    width 100%
    .table-view-horizontal
      max-width 100%
    .notice-tab-list
      >.item
        @extend .hs-font-caption-1
        background $color_black_20
        color $color_black_800
        padding 3px 8px
        border-radius 4px
        margin-right 12px
      >.clear
        color $color_theme_300
   .clear
     @extend .flex-center
     @extend .hs-font-caption-1
     min-width 48px
     background $color_black_20
     color $color_theme_300
     padding 3px 8px
     border-radius 4px
.table-view-horizontal
  @extend .flex-row
  @extend .flex-start
  max-width calc(100% - 50px)
  height 100%
  overflow hidden
.notice-tab-list
  @extend .flex-start
  width auto
  white-space nowrap
  .item
    @extend .flex-center
    padding 5px 7px
    background $color_background_gray_3
    margin-right 10px
    font-size 12px
    font-weight 500
    color $color_font_gray_1
    // border-radius 4px
  .active
    color $color_theme
    border 1px solid $color_theme
.clear
  color $color_font_blue_7
  background $color_background_gray_3
  padding 5px 7px
  font-size 12px
  font-weight 500
  // border-radius 4px
</style>
